var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1774 5.12519C11.1775 4.92936 11.2307 4.73723 11.3314 4.56924C11.432 4.40125 11.5763 4.26369 11.7489 4.17118C11.9215 4.07867 12.116 4.03467 12.3116 4.04387C12.5072 4.05307 12.6967 4.11512 12.8598 4.22343C13.023 4.33173 13.1537 4.48223 13.2381 4.65892C13.3226 4.83561 13.3575 5.03189 13.3393 5.22686C13.3211 5.42184 13.2503 5.60823 13.1346 5.76621C13.0189 5.92419 12.8625 6.04784 12.6821 6.12402C12.0624 6.38619 11.1438 6.99502 10.7863 8.01552L1.61802 15.3497C0.0190195 16.6302 0.923603 19.2085 2.97219 19.2085L21.5503 19.2085C23.5978 19.2085 24.5023 16.6302 22.9033 15.3497L14.644 8.74352C15.2703 8.33108 15.7788 7.76316 16.1199 7.09531C16.461 6.42746 16.6229 5.68254 16.5898 4.93337C16.5567 4.1842 16.3298 3.45644 15.9312 2.82124C15.5326 2.18604 14.976 1.66515 14.3159 1.30949C13.6557 0.953839 12.9145 0.775599 12.1648 0.7922C11.415 0.808801 10.6825 1.01968 10.0387 1.4042C9.39486 1.78873 8.86186 2.33375 8.49179 2.98597C8.12171 3.63819 7.92723 4.37529 7.92735 5.12519C7.92735 5.55616 8.09856 5.96949 8.4033 6.27423C8.70805 6.57898 9.12138 6.75019 9.55235 6.75019C9.98333 6.75019 10.3967 6.57898 10.7014 6.27423C11.0061 5.96949 11.1774 5.55616 11.1774 5.12519ZM12.2607 10.9969L18.4617 15.9585L6.05969 15.9585L12.2607 10.9969Z",
    fill: "#1D5D9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/type.46a744988eacff9cbdae2b63d50c7bd0.svg";
export { ForwardRef as ReactComponent };